/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  EmailContentGroupBase,
  EmailContentGroupBaseOptional,
  EmailContentGroupBaseMetaI,
  EmailContentGroupBaseTrackedI,
} from "./email-content-group-base";
import {
  EmailContentGroupBaseTracked,
  EmailContentGroupBaseMeta,
} from "./email-content-group-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  EmailContentGroupRef,
  EmailContentGroupRefOptional,
  EmailContentGroupRefMetaI,
  EmailContentGroupRefTrackedI,
} from "./email-content-group-ref";
import {
  EmailContentGroupRefTracked,
  EmailContentGroupRefMeta,
} from "./email-content-group-ref";

/**
 *
 * @export
 * @interface EmailContentGroupFull
 */
export interface EmailContentGroupFullOptional extends EmailContentGroupBaseOptional {
  /**
   *
   * @type {number}
   * @memberof EmailContentGroupFull
   */
  groupId?: number;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  groupName?: string;
}

export interface EmailContentGroupFull
  extends
    EmailContentGroupFullOptional,
    EmailContentGroupBase,
    EmailContentGroupRef {
  /**
   *
   * @type {number}
   * @memberof EmailContentGroupFull
   */
  groupId: number;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  groupName?: string;
}

export interface EmailContentGroupFullTrackedI extends EmailContentGroupBaseOptional {
  /**
   *
   * @type {number}
   * @memberof EmailContentGroupFull
   */
  groupId?: number;
  groupIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentGroupFull
   */
  groupName?: string;
  groupNameIsSet: boolean;
}

transformDatesMap.set(
  "EmailContentGroupFull",
  function (model: EmailContentGroupFull) {
    if (typeof model.updatedOn == "string")
      model.updatedOn = new Date(model.updatedOn);
    if (typeof model.createdOn == "string")
      model.createdOn = new Date(model.createdOn);
  },
);

export type EmailContentGroupFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  groupId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  groupName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var EmailContentGroupFullMeta: EmailContentGroupFullMetaI =
  {} as EmailContentGroupFullMetaI;
EmailContentGroupFullMeta = typeMeta("EmailContentGroupFull", {
  groupId: propertyMeta("groupId", false, true, true, MetaTypesBase.number),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  groupName: propertyMeta(
    "groupName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = EmailContentGroupFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([EmailContentGroupRefMeta]);
  metaI.groupId.inheritedFrom = EmailContentGroupRefMeta.groupId;
  metaI.interfaces = metaI.interfaces.concat([EmailContentGroupBaseMeta]);
  metaI.updatedOn.inheritedFrom = EmailContentGroupBaseMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = EmailContentGroupBaseMeta.updatedBy;
  metaI.createdOn.inheritedFrom = EmailContentGroupBaseMeta.createdOn;
  metaI.createdBy.inheritedFrom = EmailContentGroupBaseMeta.createdBy;
  metaI.groupName.inheritedFrom = EmailContentGroupBaseMeta.groupName;
});

export class EmailContentGroupFullTracked
  extends EmailContentGroupBaseTracked
  implements EmailContentGroupFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  groupId__I?: number = undefined;

  get groupIdIsSet() {
    return this.groupId !== undefined;
  }
  set groupIdIsSet(v: boolean) {}
  set groupId(v: undefined | number) {
    if (v !== undefined) {
      this.groupId__I = v;
      this.groupIdIsSet = true;
    } else {
      this.groupId__I = v || undefined;
      this.groupIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get groupId() {
    return this.groupId__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  groupName__I?: string = undefined;
  groupNameIsSet: boolean = false;
  set groupName(v: undefined | string) {
    if (v !== undefined) {
      this.groupName__I = v;
      this.groupNameIsSet = true;
    } else {
      this.groupName__I = v || undefined;
      this.groupNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get groupName() {
    return this.groupName__I;
  }
  constructor(config?: EmailContentGroupFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.groupIdIsSet == true && other?.groupIdIsSet == true)
      return this.groupId == other.groupId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.groupId) {
      this.groupIdIsSet = true;
    }
  }
  assignFrom(
    config: EmailContentGroupFullOptional,
    options?: AssignOptions,
  ): EmailContentGroupFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.groupId && this.groupIdApplyFilter(optionsRequired.filter)) {
      this.groupId = config.groupId;
      if (optionsRequired.unassign) this.groupIdIsSet = false;
      else this.groupIdIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.groupName && this.groupNameApplyFilter(optionsRequired.filter)) {
      this.groupName = config.groupName;
      if (optionsRequired.unassign) this.groupNameIsSet = false;
      else this.groupNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EmailContentGroupFullTrackedI {
    const cloned = {} as EmailContentGroupFullTrackedI;
    if (
      this.groupIdIsSetDeep() &&
      this.groupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.groupIdIsSet = true;
      cloned.groupId = this.groupId;
    } else {
      //cloned.groupIdIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.groupNameIsSetDeep() &&
      this.groupNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.groupNameIsSet = true;
      cloned.groupName = this.groupName;
    } else {
      //cloned.groupNameIsSet = false
    }
    if (!isDeleted(this) && !this.groupIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EmailContentGroupFullTrackedI {
    if (!this.groupIdApplyFilter(filter)) this.groupIdIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.groupNameApplyFilter(filter)) this.groupNameIsSet = false;

    return this;
  }
  groupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentGroupFullMeta.groupId,
      EmailContentGroupFullMeta,
      this.groupId,
      this,
    );
  }
  groupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.groupIdIsSet && this.groupIdApplyFilter(filter)) return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentGroupFullMeta.updatedOn,
      EmailContentGroupFullMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentGroupFullMeta.updatedBy,
      EmailContentGroupFullMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentGroupFullMeta.createdOn,
      EmailContentGroupFullMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentGroupFullMeta.createdBy,
      EmailContentGroupFullMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  groupNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentGroupFullMeta.groupName,
      EmailContentGroupFullMeta,
      this.groupName,
      this,
    );
  }
  groupNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.groupNameIsSet && this.groupNameApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.groupIdIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.groupNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
